/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for grouping the data:
 *   * GROUP : the tag group
 */
export enum TagGroupName {
  GROUP = 'GROUP'
}
